// extracted by mini-css-extract-plugin
module.exports = {"root":"PageContents_root__1EwEK","logo":"PageContents_logo__9-woC"};